"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateFingerprint = generateFingerprint;
exports.getToken = getToken;
exports.setToken = setToken;
exports.removeToken = removeToken;
exports.getNetwayCodeEnums = getNetwayCodeEnums;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _store = _interopRequireDefault(require("@/store"));

var _fingerprintjs = _interopRequireDefault(require("@fingerprintjs/fingerprintjs"));

// import localStorage from "js-cookie";
var TokenKey = "Token-Key";
var Additional = "Encryption";
var Mode = 'Mode';
var netwayCodeEnums = 'netwayCodeEnums';
var Keys = {
  u3489tu8w9i4r: 'admin',
  jd3892r8i03r3: 'agent',
  heuw9ru938h03: 'merchant'
};

function generateFingerprint() {
  return _generateFingerprint.apply(this, arguments);
}

function _generateFingerprint() {
  _generateFingerprint = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee() {
    var fp, result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _fingerprintjs.default.load();

          case 2:
            fp = _context.sent;
            _context.next = 5;
            return fp.get();

          case 5:
            result = _context.sent;
            return _context.abrupt("return", result.visitorId);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _generateFingerprint.apply(this, arguments);
}

function getToken() {
  return _getToken.apply(this, arguments);
}

function _getToken() {
  _getToken = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2() {
    var result, additional, mode;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = localStorage.getItem(TokenKey);
            additional = localStorage.getItem(Additional);
            if (additional) result = result + additional;
            mode = localStorage.getItem(Mode);
            if (_store.default) _store.default.dispatch('app/setMode', Keys[mode]);
            return _context2.abrupt("return", result);

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getToken.apply(this, arguments);
}

function setToken(_x) {
  return _setToken.apply(this, arguments);
}

function _setToken() {
  _setToken = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(token) {
    var fingerprint, mode;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return generateFingerprint();

          case 2:
            fingerprint = _context3.sent;
            token = token.concat('@', fingerprint);

            if (token.length > 4096) {
              localStorage.setItem(TokenKey, token.slice(0, 4000));
              localStorage.setItem(Additional, token.slice(4000));
            } else {
              localStorage.setItem(TokenKey, token);
            }

            mode = Object.keys(Keys).find(function (key) {
              return Keys[key] === _store.default.getters.mode;
            });
            localStorage.setItem(Mode, mode);

          case 7:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _setToken.apply(this, arguments);
}

function removeToken() {
  localStorage.removeItem(TokenKey);
  localStorage.removeItem(Additional);
}

function getNetwayCodeEnums() {
  localStorage.removeItem(netwayCodeEnums);
  return JSON.parse(localStorage.getItem(netwayCodeEnums));
}